import Statistiche from './Statistiche';
export default Statistiche;
